'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("gissler", function (security, urlUtils, $translate) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      gissler: "="
    },
    template: '<span></span>',
    link: function link($scope, $el, $attrs, controller) {
      $scope.$watch("gissler", function () {
        var code;
        if ($scope.gissler == null) {
          return "";
        }
        if ($scope.gissler.indice === 'HORS_CHARTE' || $scope.gissler.structure === 'HORS_CHARTE') {
          code = $translate("lov.structuresGissler.HC");
        } else {
          code = $translate('lov.structuresGissler.' + $scope.gissler.structure) + $translate('lov.indicesGissler.' + $scope.gissler.indice);
        }
        $el.html(code);
        $el.addClass("gissler");
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/pills/gissler.js
// module id = 2982
// module chunks = 13